import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, IconButton, Toolbar, useMediaQuery } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

// assets
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import Logo from 'components/Logo/Logo';
import { useContext } from 'react';
import { UserAuthContext } from 'context/UserAuthContext';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle }) => {
    const { isShopifyApp } = useContext(UserAuthContext);
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

    const iconBackColor = 'transparent';
    const iconBackColorOpen = '#98b2ca1f';

    // common header
    const mainHeader = (
        <Toolbar sx={{paddingLeft: !isShopifyApp() ? '0' : '1rem'}}>
            <IconButton
                disableRipple
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                edge="start"
                sx={{ color: 'white', 
                mr: !isShopifyApp() ? 2.5 : 1,
                backgroundColor: open ? iconBackColorOpen : iconBackColor, 
                ':hover': {backgroundColor: iconBackColorOpen}, ml: { xs: 0, lg: -2 } }}
            >
                {!open ? <MenuOutlinedIcon /> : <MenuOpenOutlinedIcon />}
            </IconButton>
            <Logo url={process.env.PUBLIC_URL} color="white" sx={{ml: { lg: 2 }}} />
            {!isShopifyApp() && (<>
                <HeaderContent />
            </>)}
        </Toolbar>
    );

    // app-bar params
    const appBar = {
        position: 'fixed',
        color: 'inherit',
        elevation: 0,
        sx: {
            borderBottom: `1px solid ${theme.palette.divider}`
            // boxShadow: theme.customShadows.z1
        }
    };

    return (
        <>
            {/* {!matchDownMD ? (
                <AppBarStyled open={open} {...appBar}>
                    {mainHeader}
                </AppBarStyled>
            ) : ( */}
                <AppBarStyled {...appBar}>{mainHeader}</AppBarStyled>
            {/* )} */}
        </>
    );
};

Header.propTypes = {
    open: PropTypes.bool,
    handleDrawerToggle: PropTypes.func
};

export default Header;
